import { Attributes, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class IntraGroup extends ModelBase {
    static typeName = "IntraGroup";

    public intraGroupId: number = 0;

    @Rules.StringLength(3)
    @Rules.Required()
    public intraGroupCode: string = "";

    @Rules.StringLength(50)
    @Rules.Required()
    public intraGroupName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.intraGroupCode) {
            return "New intra group";
        } else {
            return this.intraGroupCode;
        }
    }
}